// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"35e6323a","244":"38acc29f","616":"e7b1d83b","693":"c39e3ee2","767":"aa5cf5d7","835":"97069230","983":"2ef51099"}[chunkId] + ".chunk.js";
};